import {
    EnumDirection,
    EnumOperation,
    type ColumnSort,
    type FilterCondition,
    type FilterExpression,
    type ListRequest,
} from '@synqo/frontend-component-library';

/** Id of the standing-for column, which only the client knows. */
export const STANDING_FOR = 'standing_for';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

// @ai-generated 2026-10-01T13:16:07+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function daysSince(standingSince: string, now: Date): number {
    const elapsed = now.getTime() - new Date(standingSince).getTime();

    return Math.max(0, Math.floor(elapsed / MS_PER_DAY));
}

export const formatDays = (days: number): string => `${days} ${days === 1 ? 'Tag' : 'Tage'}`;

/** A duration in whole days, naming one that has not reached a day yet. */
export const renderDayCount = (days: number): string => (days < 1 ? 'unter 1 Tag' : formatDays(days));

export function renderDaysStanding(standingSince: string, now: Date): string {
    return renderDayCount(daysSince(standingSince, now));
}

// @ai-generated 2026-10-01T13:16:07+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
function translateCondition(condition: FilterCondition, now: Date): FilterCondition[] {
    if (condition.field !== STANDING_FOR) {
        return [condition];
    }

    if (!/^\d+$/.test(condition.value.trim())) {
        return [];
    }

    const days = Number(condition.value);
    const startedBefore = new Date(now.getTime() - days * MS_PER_DAY);

    return [{ field: 'started_at', value: startedBefore.toISOString(), operator: EnumOperation.LessEqual }];
}

// @ai-generated 2026-10-01T13:16:07+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
function translateExpression(expression: FilterExpression, now: Date): FilterExpression {
    return {
        ...expression,
        filters: expression.filters.flatMap((filter): (FilterExpression | FilterCondition)[] =>
            'filters' in filter ? [translateExpression(filter, now)] : translateCondition(filter, now),
        ),
    };
}

// @ai-generated 2026-10-01T13:16:07+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
function translateSort(sort: ColumnSort): ColumnSort {
    if (sort.column_name !== STANDING_FOR) {
        return sort;
    }

    return {
        column_name: 'standing_since',
        direction: sort.direction === EnumDirection.ASC ? EnumDirection.DESC : EnumDirection.ASC,
    };
}

/**
 * The request with the standing-for column's filter and sort expressed on the start of the standing,
 * since the server only knows that.
 */
// @ai-generated 2026-10-01T13:16:07+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function withStandingForTranslated(request: ListRequest, now: Date): ListRequest {
    return {
        ...request,
        filter_columns: request.filter_columns && translateExpression(request.filter_columns, now),
        sort_columns: request.sort_columns.map(translateSort),
    };
}
